// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Ke7c","footer":"Form_footer__APnGV"};